module.exports = __webpack_public_path__ + "static/media/Modern S Guitar Match off VR.386af6b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/Modern S Guitar Match off VR.mp3
// module id = ZYoP
// module chunks = 12